export function userHasCivWalletBeta(user) {
  return !!user?.beta_features?.some(f => f.name === 'civ_wallet')
}
